import { render, staticRenderFns } from "./UserPaymentMethod.vue?vue&type=template&id=92f98028&scoped=true"
import script from "./UserPaymentMethod.vue?vue&type=script&lang=js"
export * from "./UserPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./UserPaymentMethod.vue?vue&type=style&index=0&id=92f98028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f98028",
  null
  
)

export default component.exports